export const buildNumber = '20260129.3';
export const version = '3.12.0';
export const latestCommit = 'fa5afca434a22a081beb0e5be7606076e6514f38';
